import {
	type ApplicationKey,
	CORE,
	PRODUCT_DISCOVERY,
	SERVICE_DESK,
	SOFTWARE,
} from '@jira/platform__application-editions/src/application-key.tsx';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';

export const getProductReferrerKey = (productKey: ApplicationKey | null): string | null => {
	if (productKey === SOFTWARE) {
		return 'jsw';
	}
	if (productKey === SERVICE_DESK) {
		return 'jsm';
	}
	if (productKey === PRODUCT_DISCOVERY) {
		return 'jpd';
	}
	if (productKey === CORE) {
		return 'jwm';
	}
	return null;
};

export const getCcpTransactionAccountId = async (entitlementId: string) => {
	const entitlementDetails = await fetchJson(
		`/gateway/api/ccp/api/v1/entitlements/${entitlementId}/details`,
	);

	if (!entitlementDetails?.transactionAccountId) {
		// TODO: Handle errors properly
		throw Error('Could not get transactionAccountId');
	}

	return (entitlementDetails ?? {}).transactionAccountId;
};
